module.exports = __webpack_public_path__ + "media/packs/images/flags/ZA-1b83aa56fbee5319f74573e6d7203ce1.svg";